import { render, staticRenderFns } from "./customers-status-box.vue?vue&type=template&id=4acc1cdf&scoped=true&"
import script from "./customers-status-box.vue?vue&type=script&lang=js&"
export * from "./customers-status-box.vue?vue&type=script&lang=js&"
import style0 from "./customers-status-box.vue?vue&type=style&index=0&id=4acc1cdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc1cdf",
  null
  
)

export default component.exports